
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.059","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45831","data-name":"Group 45831","transform":"translate(.029)"}},[_c('rect',{attrs:{"id":"Rectangle_15413","data-name":"Rectangle 15413","width":"25","height":"25","fill":"none"}}),_c('g',{attrs:{"id":"Group_45830","data-name":"Group 45830","transform":"translate(-.127 -.399)"}},[_c('g',{attrs:{"id":"Group_45832","data-name":"Group 45832","transform":"translate(.848 3.225)","fill":"none","stroke":"#5a677a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_32955","data-name":"Path 32955","d":"M4.657 3.225v2.286m10.665-2.286v2.286M.848 19.223V7.8a2.285 2.285 0 012.286-2.289h13.712A2.285 2.285 0 0119.131 7.8v4.8M.848 19.223a2.286 2.286 0 002.286 2.286h12.188M.848 19.223v-7.618A2.285 2.285 0 013.134 9.32h13.712a2.285 2.285 0 012.285 2.286M9.99 13.129H10v.008h-.01zm0 2.286H10v.008h-.01zm0 2.285H10v.008h-.01zM7.7 15.414h.008v.008H7.7zm0 2.285h.008v.008H7.7zm-2.282-2.285h.008v.008h-.008zm0 2.285h.008v.008h-.008zm6.856-4.57h.008v.008h-.008zm0 2.286h.008v.008h-.008zm0 2.285h.008v.008h-.008zm2.286-4.57h.008v.008h-.008zm0 2.286h.008v.008h-.008z","transform":"translate(-.848 -3.225)"}}),_c('circle',{attrs:{"id":"Ellipse_883","data-name":"Ellipse 883","cx":"5.146","cy":"5.146","r":"5.146","transform":"translate(13.267 9.577)"}}),_c('path',{attrs:{"id":"Path_32956","data-name":"Path 32956","d":"M18.4 15.094v2.716h1.825","transform":"translate(-.122 -2.886)"}})])])])])
          )
        }
      }
    